module.exports = __webpack_public_path__ + "img/magento-banner@2x.a79c0607.jpg";